import { render, staticRenderFns } from "./qxc.vue?vue&type=template&id=59f3b207&scoped=true"
import script from "./qxc.vue?vue&type=script&lang=js"
export * from "./qxc.vue?vue&type=script&lang=js"
import style0 from "./qxc.vue?vue&type=style&index=0&id=59f3b207&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f3b207",
  null
  
)

export default component.exports